import script from "./popover_zmr_menu.vue?vue&type=script&setup=true&lang=js"
export * from "./popover_zmr_menu.vue?vue&type=script&setup=true&lang=js"

import "./popover_zmr_menu.vue?vue&type=style&index=0&id=09d8761d&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09d8761d"]])

export default __exports__